/* Color swap: in-place product switch for the "choose other color" swatches.
 * Each Poplight color is a separate product, so without this every swatch
 * click is a full page navigation. This swaps the main product section via
 * the Section Rendering API instead, and carries the shopper's quantity
 * across the switch.
 *
 * Progressive enhancement: the swatches stay real <a> links — if this file
 * fails to load or any step below throws, the click falls back to the
 * original full navigation.
 *
 * The flip-game bundle builder has its own add-to-cart machinery and its
 * swatches are not choose-color links; excluded via the template guard. */
(function () {
  // The flip-game bundle builder has its own machinery — never run there.
  // window._template is checked when available, but the live theme has that
  // bootstrap commented out, so the builder's own DOM is the real guard
  // (this script loads deferred, after the document is parsed).
  if (window._template && window._template.suffix === 'flip-game-new') return;
  if (
    document.querySelector(
      '.custom_bundle_wrapper, .select-shades-grid, .selected-colours-list'
    )
  ) {
    return;
  }

  var swapped = false;
  /* --- Kaching Bundles support ------------------------------------------
     The pack picker (1/2/3-pack) is this page's quantity UI: Kaching's
     config ships keepQuantityInput=false (it removes the native quantity
     input) and reinitialize_morphed_placeholders=false (it will NOT
     re-render into swapped-in DOM on its own). So after a swap we patch
     its per-page config with the new product id, re-trigger its exposed
     init, and re-select the shopper's pack. If the widget had rendered
     before but fails to come back, we hard-navigate so the buy box is
     never degraded.
     Selector for the deal inputs to be confirmed in live testing. */
  var kaching = {
    present: function () {
      return !!document.getElementById('kaching-bundles-config');
    },
    /* Layout-shift control: while Kaching re-renders (1-3s), the pack
       picker area would collapse and the add-to-cart button would jump up,
       then back down — a moving tap target. Gold-standard treatment:
       reserve the old widget's exact height with a skeleton shimmer, then
       ease to the new height if the new product has a different deal count. */
    ensureSkeletonStyle: function () {
      var VERSION = '10';
      var existing = document.getElementById('color-swap-skeleton-style');
      if (existing && existing.getAttribute('data-v') === VERSION) return;
      var style = existing || document.createElement('style');
      style.id = 'color-swap-skeleton-style';
      style.setAttribute('data-v', VERSION);
      style.textContent =
        '.color-swap-kaching-loading{display:block;}' +
        '#color-swap-kaching-slot kaching-bundle{margin:0 !important;transition:opacity 150ms ease;}' +
        '#color-swap-kaching-slot.color-swap-kaching-loading kaching-bundle{opacity:0;}' +
        /* Uniform deal-row heights: each color's descriptions differ in
           length and the selected row expands, so pickers rest at
           different heights per color (296/321/396 observed) and every
           swap moved the button ~25px. Pinning rows to the tallest
           natural size makes same-row-count pickers identical in height
           across all colors — zero motion unless a row is added/removed. */
        'kaching-bundle label{min-height:86px;box-sizing:border-box;}';
      if (!style.parentNode) document.head.appendChild(style);
    },
    settle: function (el) {
      el.classList.remove('color-swap-kaching-loading');
      var cleanup = function () {
        el.style.transition = '';
        el.style.height = '';
        el.style.minHeight = '';
        el.style.overflow = '';
      };
      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = el.offsetHeight;
      // Measure the true content height by releasing the pin: scrollHeight
      // is floored at the pinned box height, which reports "no change" for
      // shrinking content and kills the big-to-small glide.
      el.style.height = '';
      var target = el.offsetHeight;
      // No animation frames run in hidden/occluded pages — a rAF-based
      // reveal freezes the buy box pinned and clipped until the tab is
      // visible again. Animate synchronously (forced style flush), and
      // skip the animation entirely when nobody can see it.
      if (document.hidden || reduceMotion || Math.abs(target - current) < 2) {
        cleanup();
        return;
      }
      el.style.height = current + 'px';
      el.style.transition = 'height 250ms ease';
      void el.offsetHeight;
      el.style.height = target + 'px';
      setTimeout(function () {
        // Self-correcting release: if the content's true resting height
        // drifted while we animated (third-party animations), ease the
        // residue too — the shopper must never see a snap.
        el.style.transition = '';
        el.style.height = '';
        var rest = el.offsetHeight;
        if (document.hidden || Math.abs(rest - target) < 2) {
          cleanup();
          return;
        }
        el.style.height = target + 'px';
        el.style.transition = 'height 200ms ease';
        void el.offsetHeight;
        el.style.height = rest + 'px';
        setTimeout(cleanup, 240);
      }, 300);
    },
    dealInputs: function (root) {
      return root.querySelectorAll(
        'kaching-bundle input[type="radio"], kaching-bundle [role="radio"]'
      );
    },
    /* Deal radios carry opaque per-product ids, so the only cross-product
       identity of a deal is its pack quantity, parsed from the label text
       ("3 Poplights ..."). Products can have DIFFERENT deal lists (black
       sells 1-4 packs, blue 1-3), so restoring by list position would
       silently select the wrong pack — restore by quantity instead. */
    dealQuantity: function (input) {
      var label = input.closest('label') || input.parentElement;
      if (!label) return null;
      var match = label.textContent.match(/\d+/);
      return match ? parseInt(match[0], 10) : null;
    },
    selectedQuantity: function (root) {
      var inputs = this.dealInputs(root);
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked || inputs[i].getAttribute('aria-checked') === 'true') {
          return this.dealQuantity(inputs[i]);
        }
      }
      return null;
    },
    patchProductId: function (productId) {
      try {
        var cfgEl = document.getElementById('kaching-bundles-config');
        if (!cfgEl || !productId) return;
        var cfg = JSON.parse(cfgEl.textContent);
        cfg.productId = productId;
        cfgEl.textContent = JSON.stringify(cfg);
      } catch (e) {
        /* non-fatal: worst case Kaching renders with its previous config */
      }
    },
    /* Kaching's re-injection reuses its page-load instance (placeholder
       arrives stamped with the OLD product-id and data-initialized=true,
       and that instance rewrites the fresh form's variant input back to
       the old product — verified live). So: remove every stale widget and
       plant a clean placeholder carrying the new product id; their init
       then adopts it as a brand-new deal block bound to the new product.
       The product id comes from the target product's .js endpoint, fetched
       in parallel with the section render (the section markup itself has
       no reliable product-id carrier on every template). */
    rebuild: function (freshSection, productId, reservedHeight, margins) {
      document.querySelectorAll('kaching-bundle').forEach(function (el) {
        el.remove();
      });
      var stale = document.getElementById('color-swap-kaching-slot');
      if (stale) stale.remove();
      var host = freshSection.querySelector('product-form');
      if (!productId || !host || !host.parentElement) return false;
      // The reservation lives on a wrapper WE own — Kaching's init may
      // replace/reset the kaching-bundle element itself during its API
      // fetch, which would drop any styles carried on that node and let
      // the buy box collapse mid-load.
      var slot = document.createElement('div');
      slot.id = 'color-swap-kaching-slot';
      // Permanent block formatting context: overflow:hidden contained the
      // widget's inner bottom margins only while pinned — releasing it at
      // cleanup let those margins collapse out through the slot, dropping
      // its height ~25px in a single frame (the snap that survived every
      // previous fix). flow-root gives containment that never turns off,
      // without clipping overhanging badges.
      slot.style.display = 'flow-root';
      if (margins) {
        slot.style.marginTop = margins.top + 'px';
        slot.style.marginBottom = margins.bottom + 'px';
      }
      var placeholder = document.createElement('kaching-bundle');
      placeholder.setAttribute('product-id', String(productId));
      slot.appendChild(placeholder);
      if (reservedHeight > 0) {
        this.ensureSkeletonStyle();
        // Pin the height outright: the incoming widget occupies layout even
        // at opacity 0, so with only a min-height the slot silently GROWS
        // when the new picker is taller than the old one (3-pack -> 4-pack
        // colors) — the jump QA caught. Pinned + clipped, nothing that
        // renders inside can move the page until the animated reveal.
        slot.style.height = reservedHeight + 'px';
        slot.style.overflow = 'hidden';
        slot.classList.add('color-swap-kaching-loading');
      }
      host.parentElement.insertBefore(slot, host);
      return true;
    },
    reinit: function () {
      if (typeof window.__kachingBundlesInitializeInternal === 'function') {
        window.__kachingBundlesInitializeInternal();
      }
    },
    restore: function (freshSection, quantity, hadWidget, fallbackUrl, expectedId) {
      var self = this;
      var waited = 0;
      var timer = setInterval(function () {
        // Kaching may re-inject a widget from its stale page-load instance
        // alongside our clean placeholder — purge anything with the wrong
        // product id before judging the render.
        if (expectedId) {
          document.querySelectorAll('kaching-bundle').forEach(function (el) {
            if (el.getAttribute('product-id') !== String(expectedId)) el.remove();
          });
        }
        var inputs = self.dealInputs(freshSection);
        if (inputs.length) {
          clearInterval(timer);
          var slot = document.getElementById('color-swap-kaching-slot');
          var revealed = false;
          var reveal = function () {
            if (revealed) return;
            revealed = true;
            if (slot) self.settle(slot);
          };
          // Never hold a hidden buy box for long, whatever happens below.
          setTimeout(reveal, 1500);
          if (quantity == null) {
            reveal();
            return;
          }
          // Exact quantity match first; otherwise the nearest pack BELOW
          // the shopper's choice (black's 4-pack -> blue's 3-pack), never
          // silently above it.
          var best = null;
          var bestQty = -1;
          for (var i = 0; i < inputs.length; i++) {
            var q = self.dealQuantity(inputs[i]);
            if (q == null) continue;
            if (q === quantity) {
              best = inputs[i];
              break;
            }
            if (q < quantity && q > bestQty) {
              bestQty = q;
              best = inputs[i];
            }
          }
          if (best) best.click();
          // Reveal on CONDITION, not on a timer: the selected deal row
          // renders ~11px taller than unselected ones, so revealing before
          // Kaching finishes repainting the selection makes every row
          // shift as the options appear. Hold until the widget's height
          // has been stable for two consecutive ticks (the 800ms cap
          // above still guarantees the reveal).
          var lastH = -1;
          var stableTicks = 0;
          var stability = setInterval(function () {
            if (revealed) {
              clearInterval(stability);
              return;
            }
            var kb = freshSection.querySelector('kaching-bundle');
            var h = kb ? kb.offsetHeight : 0;
            if (h > 0 && h === lastH) {
              stableTicks++;
              // Kaching animates its selected-row expand/collapse after our
              // restore click; a 2-tick gate was fooled by mid-animation
              // plateaus (measured 321px transient vs 296px resting -> 25px
              // snap at cleanup). ~300ms of continuous stability outlasts it.
              if (stableTicks >= 5) {
                clearInterval(stability);
                reveal();
              }
            } else {
              stableTicks = 0;
              lastH = h;
            }
          }, 60);
        } else {
          waited += 150;
          if (waited >= 3000) {
            clearInterval(timer);
            if (hadWidget) {
              try { console.info('[color-swap] fallback: pack picker did not render in 3s -> full navigation'); } catch (e) {}
              window.location.href = fallbackUrl;
            }
          }
        }
      }, 150);
    },
  };

  function bind() {
    document
      .querySelectorAll('.choose-other-flavors a:not([data-swap-bound])')
      .forEach(function (link) {
        link.setAttribute('data-swap-bound', '1');
        link.addEventListener('click', function (event) {
          // Let open-in-new-tab clicks behave normally.
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          event.preventDefault();
          // Already on this color — nothing to do.
          if (link.classList.contains('active')) return;
          swap(link);
        });
      });
  }

  function swap(link) {
    var sectionEl = link.closest('[id^="shopify-section-"]');
    if (!sectionEl) {
      window.location.href = link.href;
      return;
    }

    var quantityInput = sectionEl.querySelector('input[name="quantity"]');
    var quantity = quantityInput ? quantityInput.value : null;

    var oldKachingEl = sectionEl.querySelector('kaching-bundle');
    var hadKachingWidget = !!oldKachingEl;
    var kachingHeight = 0;
    var kachingMargins = null;
    if (oldKachingEl) {
      // Measure whichever element owns the page space: the previous slot if
      // one exists (its inner widget has margin 0), else the raw widget.
      // The widget's own margins are neutralized inside the slot and carried
      // BY the slot instead — margin-collapse behavior then never changes
      // between loading, reveal, and rest, which is what caused the small
      // hop at reveal time.
      var refEl = oldKachingEl.closest('#color-swap-kaching-slot') || oldKachingEl;
      var mcs = getComputedStyle(refEl);
      kachingHeight = Math.round(refEl.getBoundingClientRect().height);
      kachingMargins = {
        top: parseFloat(mcs.marginTop) || 0,
        bottom: parseFloat(mcs.marginBottom) || 0,
      };
    }
    var kachingQuantity = kaching.selectedQuantity(sectionEl);

    sectionEl.style.opacity = '0.5';

    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionEl.id.replace('shopify-section-', ''));

    // The target product's id (for Kaching's placeholder) — fetched in
    // parallel; failure is non-fatal, the Kaching fallback handles it.
    var productDataPromise = kaching.present()
      ? fetch(url.origin + url.pathname + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([
      fetch(url.toString(), { headers: { Accept: 'text/html' } }).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      }),
      productDataPromise,
    ])
      .then(function (results) {
        var html = results[0];
        var productData = results[1];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sectionEl.id) || doc.body.firstElementChild;
        if (!fresh || !fresh.querySelector('product-form, .product')) {
          throw new Error('unexpected section response');
        }

        // Custom elements in the fresh markup (variant pickers, product form,
        // media gallery, quantity input) re-initialize themselves on insertion.
        sectionEl.replaceWith(fresh);
        swapped = true;

        if (quantity && quantity !== '1') {
          var freshQuantity = fresh.querySelector('input[name="quantity"]');
          if (freshQuantity) {
            freshQuantity.value = quantity;
            freshQuantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // Keep the theme-preview id in the address bar during draft-theme QA
        // — otherwise a copied/reopened URL silently lands on the live theme
        // and the feature "disappears". Shopify strips the query param into a
        // cookie on entry, so the runtime theme object is the reliable
        // source. No-op on the published theme (role === 'main').
        var pushUrl = link.href;
        var shopifyTheme = window.Shopify && window.Shopify.theme;
        if (shopifyTheme && shopifyTheme.role && shopifyTheme.role !== 'main') {
          var u = new URL(link.href, window.location.origin);
          u.searchParams.set('preview_theme_id', shopifyTheme.id);
          pushUrl = u.toString();
        }
        window.history.pushState({ colorSwap: true }, '', pushUrl);
        var heading = fresh.querySelector('.product__title h1, .product__title, h1');
        if (heading) document.title = heading.textContent.trim();

        document.dispatchEvent(
          new CustomEvent('variant:change', { detail: { source: 'color-swap' } })
        );
        if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
          window.jdgm.customizeBadges();
        }
        if (kaching.present()) {
          var newProductId = productData && productData.id;
          if (newProductId) {
            kaching.patchProductId(newProductId);
            kaching.rebuild(fresh, newProductId, kachingHeight, kachingMargins);
            kaching.reinit();
            kaching.restore(fresh, kachingQuantity, hadKachingWidget, link.href, newProductId);
          } else if (hadKachingWidget) {
            // Can't rebuild the pack picker correctly — a degraded buy box
            // is never acceptable, so fall back to a full navigation.
            try { console.info('[color-swap] fallback: product data fetch failed -> full navigation'); } catch (e) {}
            window.location.href = link.href;
            return;
          }
        }

        bind();
      })
      .catch(function (e) {
        try { console.info('[color-swap] fallback: swap failed -> full navigation', e); } catch (err) {}
        window.location.href = link.href;
      });
  }

  // Back/forward after an in-place swap: a real load is the only state
  // that's guaranteed consistent.
  window.addEventListener('popstate', function () {
    if (swapped) window.location.reload();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  if (kaching.present()) kaching.ensureSkeletonStyle();
})();
